import React from 'react';
import { Users, UserCheck } from 'lucide-react';
import { AdminStatCard } from './AdminStatCard';
import type { OrganizationStatistics } from '@/lib/api/statistics';

interface AdminPatientsTabProps {
  statistics: OrganizationStatistics | null;
  isLoading: boolean;
}

export const AdminPatientsTab: React.FC<AdminPatientsTabProps> = ({ statistics, isLoading }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <AdminStatCard
          icon={<Users className="h-6 w-6" />}
          title="Total Patients"
          value={statistics?.patients.totalPatients || 0}
          isLoading={isLoading}
        />
        <AdminStatCard
          icon={<UserCheck className="h-6 w-6 text-green-600" />}
          title="New Registrations"
          value={statistics?.patients.newRegistrations || 0}
          isLoading={isLoading}
        />
        <AdminStatCard
          icon={<UserCheck className="h-6 w-6 text-purple-600" />}
          title="Active Patients"
          value={statistics?.patients.activePatients || 0}
          isLoading={isLoading}
        />
      </div>
      {statistics?.patients.patients && statistics.patients.patients.length > 0 && (
        <div className="rounded-lg border border-gray-200 bg-white">
          <div className="border-b border-gray-200 px-4 py-3">
            <h3 className="font-hanken text-sm font-semibold text-gray-700">Patients</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px] border-collapse">
              <thead className="bg-gray-50">
                <tr>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Name
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Age/Gender
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Phone
                  </th>
                  <th className="whitespace-nowrap px-4 py-2.5 text-left align-middle font-hanken text-xs font-medium text-gray-600">
                    Registration Date
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {statistics.patients.patients.map((p) => (
                  <tr key={p.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-900">
                      {p.name}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {p.age !== undefined ? `${p.age} / ${p.gender || '-'}` : p.gender || '-'}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {p.phone || '-'}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-hanken text-sm text-gray-600">
                      {new Date(p.registrationDate).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
